
import { Bell, Search } from "lucide-react";
import { Input } from "@/components/ui/input";

export function Header() {
  return (
    <header className="flex h-16 items-center gap-6 border-b border-white/10 bg-white/80 backdrop-blur-md px-4 sm:px-6 lg:px-8 shadow-sm relative z-20">
      <form className="flex-1">
        <div className="relative max-w-md">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-figma-primary/60" />
          <Input
            type="search"
            placeholder="Buscar en el sistema..."
            className="w-full rounded-figma-input border-figma-primary/20 bg-white/50 pl-10 text-figma-primary placeholder:text-figma-primary/60 focus:border-figma-primary focus:bg-white focus:ring-figma-primary/20"
          />
        </div>
      </form>
      <div className="flex items-center gap-4">
        <button className="rounded-full p-2 hover:bg-gray-100">
          <Bell className="h-4 w-4" />
        </button>
      </div>
    </header>
  );
}
